import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  UFDate,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import PaymentMode from "../../../components/Common/chooseFields/paymentMode"
import LoadingButton from "../../../components/Common/LoadingButton"
import Location from "../../../components/Common/chooseFields/location"
import lightTrash from "../../../assets/icons/light-trash.svg"
import Priority from "../../../components/Common/chooseFields/priority"
import {
  fetchMRRequest,
  fetchRequest,
  postMaterialRequest,
  postMaterialRequestFinance,
} from "../../../services/procurement/materialrequest"
import moment from "moment"
import Productcode from "../../../components/Common/chooseFields/Product"
import { fetchProjecrtMaster } from "../../../services/projectManager/projectMaster"
import MaterialProjectNo from "../../../components/Common/chooseFields/materailProject"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import MaterialProductList from "../../../components/Common/chooseFields/materialProductList"
import { useSelector } from "react-redux"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getCode } from "../../../services/inventory"
import { p } from "@table-library/react-table-library/styles-492c6342"
import MaterialRequest from "../../../components/Common/chooseFields/materialrequest"
import ProductList from "../../../components/Common/chooseFields/productList"
import EstProductsLi from "../../../components/Common/chooseFields/estProductLists"

const schema = yup.object().shape({
  parent_id: yup.mixed().nullable(),
  request_date: yup
    .mixed()
    .required("Request Date is required")
    .test(
      "is-future-date",
      "Make sure the request date is forward-looking",
      function (value) {
        if (!value) return true
        const currentDate = moment()
        const selectedDate = moment(value)
        return selectedDate.isSameOrAfter(currentDate, "day")
      }
    ),
  exp_Delivery_date: yup
    .mixed()
    .test(
      "is-future-date",
      "Make sure the exp delivery date is forward-looking",
      function (value) {
        if (!value) return true
        const currentDate = moment()
        const selectedDate = moment(value)
        return selectedDate.isSameOrAfter(currentDate, "day")
      }
    )
    .required("Delivery Date is required"),
    material_req: yup
    .array()
    .of(
      yup.object().shape({
        product_id: yup.mixed().required("Product code is required"),

        initial_quantity: yup.number().nullable().default(0),

        requestquantity: yup
          .number()
          .typeError("Quantity must be a number")
          .required("Quantity is required")
          .min(0, "Quantity must be at least 0")
          .test(
            "lte-initial-when-parent",
            function (value) {
              const { initial_quantity } = this.parent; // row value

              /* root object lives in the first element of `from` */
              const root = this.from?.[this.from.length - 1];
              const parent_id = root?.value?.parent_id;

              const max = initial_quantity ?? 0;

              if (parent_id != null && value > max) {
                return this.createError({
                  message: `Quantity cannot exceed ${max}`,
                });
              }
              return true;
            }
          ),
      })
    )
    .min(1, "Add at least one material request")
    .required("Material request list is required"),
})

const EditSMR = ({ fromDashboard, projectValue, toggle }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Outward SMR${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const now = moment()
  const [isLoading, setIsLoading] = useState(false)
  const [isDraftLoading, setIsDraftLoading] = useState(false)
  const [projectID, setProjectID] = useState()
  const [action, setAction] = useState()
  const [materialsData, setMaterialsData] = useState([])

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const locations = useLocation();
  const crumbname = locations?.state?.crumbname || ""

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      parent_id: null,
      contact_number: "",
      requested_by: "",
      code_edit: 0,
      request_date: moment(now, "YYYY-MM-DD").toDate(),
      delivery_location: null,
      material_req: [
        {
          id: "",
          product_id: null,
          quantity: "",
          requestquantity: "",
          description: "",
          // priority: null,
          initial_quantity: "",
          received_quantity: "",
        },
      ],
    },
  })
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   shouldFocusError: true,
  // })
  const {
    fields: materialFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "material_req",
  })

  const handleRegistration = async data => {
    console.log(`data`, data)
    // const Requestarray = data?.material_req?.map(dt => ({
    //   project_material_id: dt?.id,
    //   material_id: dt?.product_id?.value,
    //   // priority: dt?.priority?.value,
    //   // description: dt?.description,
    //   requested_quantity: dt?.requestquantity,
    //   // unit_id: dt?.unit_id,
    // }))
    const Requestarray = data?.material_req
      ?.filter(dt => Number(dt?.requestquantity) > 0)
      .map(dt => ({
        project_material_id: dt?.id,
        material_id: dt?.product_id?.value,
        // priority: dt?.priority?.value,
        // description: dt?.description,
        requested_quantity: dt?.requestquantity,
        // unit_id: dt?.unit_id,
      }))
    try {
      action === 1 ? setIsDraftLoading(true) : setIsLoading(true)
      const update = await postMaterialRequestFinance({
        ...data,
        // save_as_draft: 1,
        requested_by: loggedUser?.data?.id,
        contact_number: 0,
        delivery_location: data?.delivery_location,
        // project_id: data?.project_id,
        parent_id: data?.parent_id?.value,
        materials: Requestarray,
        exp_Delivery_date: moment(data?.exp_Delivery_date).format("YYYY-MM-DD"),
        request_date: moment(data?.request_date).format("YYYY-MM-DD"),
      })
      if (fromDashboard) {
        toggle()
      } else {
        navigate("/inventory-outward-smr")
      }
      toastSuccess(update?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setIsDraftLoading(false)
    }
  }

  const handleProjectChange = () => {
    const { parent_id } = getValues()
    fetchProjectData(parent_id?.value)
    setProjectID(parent_id?.value)
  }

  useEffect(() => {
    if (fromDashboard || location?.state?.id) {
      setValue("parent_id", projectValue)
      fetchProjectData(location?.state?.id ? location?.state?.id : id)
      setValue(
        "parent_id",
        location?.state?.id
          ? { value: location?.state?.id, label: location?.state?.code }
          : null
      )
      setProjectID(id)
    }
    const fetchMrEdit = async id => {
      const responce = await fetchMRRequest(id)
      console.log(`responce edit`, responce)
      const materialsArr = responce?.data?.materials?.map(dt => ({
        product_id: {
          label: `${dt?.product?.product_code} - ${dt?.product?.description}`,
          value: dt?.product?.id,
        },
        quantity: Number(dt?.used_quantity) > 0 ? dt?.used_quantity : 0,
        requestquantity: dt?.requested_quantity,
        description: dt?.product?.description,
        initial_quantity: dt?.product?.requestedCount,
      }))
      // setMaterialsData(materialsArr)
      reset({
        ...responce?.data,
        parent_id: {
          label: responce?.data?.project?.parent_id,
          value: responce?.data?.project?.id,
        },
        project_name: responce?.data?.project?.project_name,
        exp_Delivery_date: responce?.data?.exp_Delivery_date,
        material_req: materialsArr,
      })
    }
    const getUniqueCode = async (code, modal, type) => {
      const response = await getCode(code, modal, type)
      if (!id) {
        setValue("code", response?.code?.code)
      }
      setValue("code_edit", response?.code?.manualoverride)
    }
    if (id) {
      fetchMrEdit(id)
    }
    // if (!id) {
    getUniqueCode("code", "NewMaterialRequest", "Material Request(SM)")
    // }
  }, [fromDashboard, id, location])

  const fetchProjectData = async idData => {
    const response = await fetchMRRequest(idData)
    console.log("responsehaha", response)
    if (idData == response.data?.id) {
      const materialsArr = response?.data?.materials?.map(dt => ({
        product_id: {
          label: `${dt?.product?.product_code} - ${dt?.product?.description}`,
          value: dt?.product?.id,
        },
        quantity: Number(dt?.used_quantity) > 0 ? dt?.used_quantity : 0,
        requestquantity: dt?.requested_quantity,
        description: dt?.product?.description,
        initial_quantity: dt?.requested_quantity,
        store_quantity:
          Number(dt?.product?.storeCount) > 0 ? dt?.product?.storeCount : 0,
      })).filter(item => Number(item.store_quantity) <= 0);

      console.log(`Requestarray`, materialsArr)

      const previousDatas = getValues()
      setMaterialsData(materialsArr)
      reset({
        ...previousDatas,
        // project_id: response?.data?.project?.id,
        project_name: response.data?.project_name,
        material_req: materialsArr,
        delivery_location: response.data?.location?.name,
      })
    }
  }
  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-2">
                  {!fromDashboard ? (
                    <Breadcrumbs
                      title="Inventory"
                      breadcrumbObject={[
                        { title: "Inventory", link: "/inventory" },
                        { title: crumbname || "Masters", link: "/inventory" },
                        {
                          title: "Outward SMR",
                          link: "/inventory-outward-smr",
                        },
                        {
                          title: id ? "Edit Outward SMR" : "Add Outward SMR",
                          link: "",
                        },
                      ]}
                    />
                  ) : (
                    <div></div>
                  )}
                  <div>
                    {/* <LoadingButton
                      type="submit"
                      color="primary"
                      className="btn-sm btn-rounded waves-effect waves-light mb-3"
                      onClick={() => setAction(1)}
                      loading={isDraftLoading}
                    >
                      {id ? "Update As Draft" : "Save As Draft"}
                    </LoadingButton> */}
                    <LoadingButton
                      form={`request-form`}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      onClick={() => setAction(2)}
                      className={"px-2 mb-3 ms-2 me-1 btn btn-primary"}
                      type="submit"
                    >
                      {fromDashboard ? "Save" : id ? "Update" : "Save"}
                    </LoadingButton>
                  </div>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="mb-1 mt-2">
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>SMR Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"code"}
                          invalid={!!errors.code}
                          disabled={
                            watch("code_edit") == 0 ||
                            watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>PMR Reference</Label>
                        <MaterialRequest
                          control={control}
                          placeholder="Select the MR code"
                          name={"parent_id"}
                          target={fromDashboard ? ".modal" : "body"}
                          onSelectChange={handleProjectChange}
                          invalid={!!errors.parent_id}
                          disabled={fromDashboard}
                          clearable={true}
                          status={2}
                          isApproved={false}
                          projectOnly={true}
                          //   is_budgeted={1}
                          //   is_mr={1}
                        />
                        <FormFeedback invalid>
                          {errors.parent_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>

                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Request Date <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"request_date"}
                          invalid={!!errors.request_date}
                        />
                        <FormFeedback invalid>
                          {errors.request_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Exp. Delivery Date{" "}
                          <span className="mandatory">*</span>
                        </Label>
                        <UFDate
                          control={control}
                          name={"exp_Delivery_date"}
                          invalid={!!errors.exp_Delivery_date}
                        />
                        <FormFeedback invalid>
                          {errors.exp_Delivery_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr className="m-0" />
                  <Row className="py-2 mt-1">
                    <h5 className="edittheamtitle">Material Details</h5>
                  </Row>
                  <Row className="mb-4">
                    <Col lg={12}>
                      <table className="estimation-table mb-4">
                        <thead>
                          <tr>
                            <th>Product Code</th>
                            <th>Store Quantity</th>
                            <th>Quantity</th>
                            {watch("parent_id") == null && <th></th>}
                          </tr>
                        </thead>
                        <tbody>
                          {materialFields.map((item, index) => (
                            <tr key={`materialFields_${item?.id || index}`}>
                              <td className="ps-1">
                                <EstProductsLi
                                  control={control}
                                  placeholder="Product"
                                  name={`material_req.${index}.product_id`}
                                  index={index}
                                  dropView={true}
                                  showDescription={true}
                                  disabled={
                                    watch("parent_id") == null ? false : true
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]?.product_id
                                      ?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-2">
                                <UFInput
                                  control={control}
                                  placeholder="Store Quantity"
                                  name={`material_req.${index}.store_quantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]
                                      ?.store_quantity
                                  }
                                  disabled
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]
                                      ?.store_quantity?.message
                                  }
                                </FormFeedback>
                              </td>
                              <td className="ps-2">
                                <UFInputNumber
                                  control={control}
                                  placeholder="Quantity"
                                  name={`material_req.${index}.requestquantity`}
                                  invalid={
                                    !!errors?.material_req?.[index]
                                      ?.requestquantity
                                  }
                                />
                                <FormFeedback invalid>
                                  {
                                    errors?.material_req?.[index]
                                      ?.requestquantity?.message
                                  }
                                </FormFeedback>
                              </td>
                              {watch("parent_id") == null && (
                                <td>
                                  <div className="pb-1 px-2 d-flex justify-content-center">
                                    <div
                                      className="trash-img pointer"
                                      onClick={() => materialRemove(index)}
                                    >
                                      <TrashIcon />
                                    </div>
                                  </div>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {watch("parent_id") == null && (
                        <Col
                          lg="12"
                          xs={12}
                          md={2}
                          sm={12}
                          className="d-flex justify-content-end"
                        >
                          <Button
                            color="primary"
                            className="addButton mt-2"
                            onClick={() =>
                              materialAppend({
                                product_id: "",
                                description: "",
                                quantity: "",
                                requestquantity: "",
                              })
                            }
                          >
                            + Row
                          </Button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </Card>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditSMR
